import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-session-warning-modal',
  imports: [CommonModule],
  templateUrl: './session-warning-modal.component.html',
})
export class SessionWarningModalComponent {
  @Output() continueSession = new EventEmitter<void>();

  continue() {
    this.continueSession.emit();
  }
}
